import * as Bank from './Bank'
import * as Card from './Card'

export const Payments = {
  Bank,
  Card,
}
